import {buildField} from '@eitje/form'
import {t} from '@eitje/bridge'
import {Layout, Text, Dropdown} from '~/components'
import {FieldsDropdown} from './fields_dropdown'

const Inner = ({fieldIndex}) => (
	<Dropdown
		trigger={
			<Layout className="select-trigger-container multi-action-field-select-trigger" tabIndex={0}>
				<Text color="dark-grey">...</Text>
			</Layout>
		}
	>
		<FieldsDropdown type="update" fieldIndex={fieldIndex} />
		<FieldsDropdown type="clear" fieldIndex={fieldIndex} />
	</Dropdown>
)

const PlaceholderFieldInput = buildField(Inner, {
	className: 'eitje-select placeholder-field',
	clearIcon: false,
	label: () => t('modals.multi_action.add_item'),
})

export const PlaceholderField = ({fieldIndex, rightElement}) => (
	<PlaceholderFieldInput field="placeholder_field" fieldIndex={fieldIndex} rightElement={rightElement} />
)
